import { defineComponent as _defineComponent } from 'vue'
import { useRouterTransition } from '@/modules/common/composables/useRouterTransition';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterViewWithTransition',
  setup(__props) {

const { path, transitionComponent } = useRouterTransition();

return { __sfc: true,path, transitionComponent }
}

})